export enum IconType {
  Disabled = "disabled",
  Active = "active",
  Enabled = "enabled",
}
